const Auth = {
  login: "/login",
  forgotPasswordVerifyOtpScreen: "/forgotPasswordVerifyOtpScreen",
  verifyRegistrationOtp: "/verifyRegistrationOtp",
  verifyGoogleRegistrationOtp: "/verifyGoogleRegistrationOtp",
  googleRegistration: "/googleRegistration",
  register: "/register",
  forgotPassword: "/forgotPassword",
  resetPassword: "/resetPassword",
  changePassword: "/changePassword",
  logout: "/logout",
  guest: "/guest",
  enrollCohort: "/enroll-cohort",
  default: "/",
};

const Home = {
  default: "/",
  home: "/dashboard",
};

const FormBuilder = {
  default: "/form-builder",
};

const Forms = {
  default: "/forms",
};

const FormsFolder = {
  default: "/forms/folder",
  folder: "/forms/folder/*",
};
const RespondedForms = {
  default: "/responded-forms",
};
const Templates = {
  default: "/templates",
};
const Pricing = {
  default: "/subscription",
  success: "/subscription/success",
  verify: "/subscription/verify/:accountId",
  failure: "/subscription/failure",
};

const FormSubmission = {
  default: "/form-submission",
};

const FormLinkSubmission = {
  default: "/formlink-submission",
};
const Submissions = {
  submission: "/submissions",
  default: "/submissions",
};

const Profile = {
  default: "/profile",
  organization: "/organization",
};

const Dashboard = {
  default: "/dashboard",
};

const profileDetail = {
  default: "/profiledetail",
};

const Response = {
  default: "/form-response",
};
const formLinkResponse = {
  default: "/form-formlink-response",
};

const EditResponse = {
  default: "/form-edit-response",
};

const editFormLinkResponse = {
  default: "/form-edit-formlink-response",
};
const Statistics = {
  stats: "/stats",
  default: "/stats",
};

const PageNotFound = {
  notFound: "/404",
};

const payment = {
  success: "/payment-successful",
  failure: "/payment-failure",
};
const theme = {
  default: `${FormBuilder.default}/theme`,
};

const BASE_PATH = "/forms";

const withBasePath = (value: any): any => {
  if (typeof value === "string") {
    return value === "/" ? BASE_PATH : `${BASE_PATH}${value}`;
  }
  const prefixed: any = {};
  for (const key in value) {
    prefixed[key] = withBasePath(value[key]);
  }
  return prefixed;
};

export const Routes = withBasePath({
  Auth,
  Home,
  FormBuilder,
  PageNotFound,
  Forms,
  FormsFolder,
  RespondedForms,
  Templates,
  FormSubmission,
  Profile,
  Dashboard,
  profileDetail,
  Submissions,
  Response,
  Statistics,
  payment,
  theme,
  EditResponse,
  Pricing,
  editFormLinkResponse,
  FormLinkSubmission,
  formLinkResponse
  //PublicDefault
});
